<script setup>
// Config do node "Enviar resposta": como a resposta é entregue (texto, áudio ou
// ambos). Compilado na instrução; o áudio usa o TTS do agente.
import { useI18n } from 'vue-i18n';

defineProps({ data: { type: Object, required: true } });
const emit = defineEmits(['update', 'remove', 'close']);
const { t } = useI18n();

const FORMATS = ['text', 'audio', 'both'];
</script>

<template>
  <div class="p-4">
    <div class="mb-1 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <span class="i-lucide-send text-n-slate-11" />
        <h3 class="text-sm font-semibold text-n-slate-12">
          {{ data.label || t('AI_AGENTS.FLOW.SEND.TITLE') }}
        </h3>
      </div>
      <button class="i-lucide-x text-n-slate-10" @click="emit('close')" />
    </div>
    <p class="mb-3 text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.SEND.SUBTITLE') }}
    </p>

    <label class="mb-2 block text-xs font-medium text-n-slate-11">
      {{ t('AI_AGENTS.FLOW.SEND.FORMAT') }}
    </label>
    <div class="grid grid-cols-3 gap-2">
      <button
        v-for="f in FORMATS"
        :key="f"
        type="button"
        class="rounded-lg border px-2 py-2 text-center text-xs transition-all"
        :class="
          (data.responseFormat || 'text') === f
            ? 'border-n-brand bg-n-brand/10 text-n-slate-12'
            : 'border-n-weak text-n-slate-11 hover:border-n-slate-8'
        "
        @click="emit('update', { responseFormat: f })"
      >
        {{ t(`AI_AGENTS.FLOW.SEND.OPTS.${f}`) }}
      </button>
    </div>
    <p class="mt-3 text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.SEND.HINT') }}
    </p>

    <label class="mb-1 mt-4 block text-xs font-medium text-n-slate-11">
      {{ t('AI_AGENTS.FLOW.SEND.FIXED_MSG') }}
    </label>
    <textarea
      :value="data.fixedMessage"
      rows="3"
      :placeholder="t('AI_AGENTS.FLOW.SEND.FIXED_MSG_PH')"
      class="w-full rounded-lg border border-n-weak bg-n-solid-1 px-2.5 py-1.5 text-sm"
      @input="emit('update', { fixedMessage: $event.target.value })"
    />
    <p class="mt-1 text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.SEND.FIXED_MSG_HINT') }}
    </p>

    <button
      class="mt-4 w-full rounded-lg border border-n-ruby-7 py-2 text-sm font-medium text-n-ruby-9 hover:bg-n-ruby-3"
      @click="emit('remove')"
    >
      {{ t('AI_AGENTS.FLOW.REMOVE_NODE') }}
    </button>
  </div>
</template>
